import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import AppWithPersistor from './App';

const isDev = window.location.host === 'dev.pravo.tracktrack.ru';
const isProd = window.location.host === 'tracktrack.ru';

if (isDev || isProd) {
    Sentry.init({
        dsn: 'https://55d1b2218f494a90a9841c8ab92d6cba@o268056.ingest.sentry.io/6074179',
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        environment: isProd ? 'production' : isDev ? 'development' : '',
    });
}

ReactDOM.render(<AppWithPersistor />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js